import { render } from "./TanpokenSettingItem.vue?vue&type=template&id=70b6804f&ts=true"
import script from "./TanpokenSettingItem.vue?vue&type=script&lang=ts"
export * from "./TanpokenSettingItem.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\02_システム\\20_帳票テンプレート\\02_開発\\report-template\\web-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__